<template>
  <div class="p-3">
    <b-row>
      <b-col class="mb-3">
        <h1>User Management</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mb-3">
        <b-button size="sm" variant="primary" @click="LoadItem()">
          <b-icon-plus/>
          Add User
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div ref="table-container">
          <b-row class="mb-2">
            <b-col cols="6" lg="3" md="4">
              <b-input-group size="sm" class="mb-2">
                <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Search by Email"
                    debounce="800"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''"
                  >Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>

            </b-col>
            <b-col cols="6" lg="9" md="8">
              <b-input-group size="sm" class="mb-2">
                <treeselect
                    v-model="filterByRole"
                    :multiple="true"
                    :options="roles"
                    placeholder="Search by Role"
                    value-consists-of="LEAF_PRIORITY"
                ></treeselect>
              </b-input-group>
            </b-col>
            <!--            <b-col cols="6" lg="9" md="8">-->
            <!--              <b-pagination-->
            <!--                  class="table-pagination"-->
            <!--                  v-model="currentPage"-->
            <!--                  :total-rows="rows"-->
            <!--                  :per-page="perPage"-->
            <!--                  size="sm"-->
            <!--                  align="right"-->
            <!--                  limit="10"-->
            <!--                  v-if="rows > 0"-->
            <!--              ></b-pagination>-->
            <!--            </b-col>-->
          </b-row>

          <b-row>
            <b-col>
              <b-table
                  bordered
                  small
                  responsive
                  sticky-header="60vh"
                  striped
                  class="table-general"
                  sort-by="email"
                  :items="filteredItems"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :busy="httpIsBusy"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(index)="data"
                >{{ 1 + data.index + (currentPage - 1) * perPage }}
                </template>
                <template v-slot:cell(roles)="data">
                  <span>{{ data.value.join() }}</span>
                </template>
                <template v-slot:cell(action)="data">
              <span
                  class="clickable text-primary mx-1"
                  @click="LoadItem(data.item)"
              >
                <b-icon-pencil/>
              </span>
                  <span
                      class="clickable text-primary mx-1"
                      @click="DeleteItem(data.item)"
                  >
                <b-icon-trash/>
              </span>
                  <span
                      class="clickable text-primary mx-1"
                      @click="resetPassword(data.item)"
                  >
                <b-iconstack
                    class="btn-inline-text"
                    title="Reset Password"
                >
                  <b-icon
                      stacked
                      icon="arrow-repeat"
                      scale="1.25"
                      rotate="125"
                  ></b-icon>
                  <b-icon stacked icon="lock-fill" scale="0.5"></b-icon>
                </b-iconstack>
              </span>
                </template>
              </b-table>
              <!-- <small class="text-muted float-right mr-2">Current Page: {{ currentPage }}. Total rows: {{ rows }}</small>-->
              <small class="text-muted float-right mr-2">Total users: {{ rows }}</small>
            </b-col>
          </b-row>
        </div>
        <div v-if="httpIsBusy" class="fixed-bottom text-right mb-2 pr-5">
          <b-spinner small class="align-middle"/>
          <small>{{ ' Loading...' }}</small>
        </div>
      </b-col>
    </b-row>

    <b-modal centered size="lg" v-model="modal" :title="isEdit ? 'Edit' : 'Add'">
      <b-form ref="form-user">
        <div class="form-group row">
          <div class="col-sm-3">
            <label>Email</label>
          </div>
          <div class="col-sm-9">
            <b-input
                class="form-control-sm"
                v-model.trim="formItem.email"
                required
                type="email"
                @keyup="_consoleLog"
            ></b-input>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <label>Roles</label>
          </div>
          <div class="col-sm-9">
            <treeselect
                v-model="formItem.roles"
                :multiple="true"
                :options="roles"
                value-consists-of="LEAF_PRIORITY"
                required
            ></treeselect>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <label>Brands</label>
          </div>
          <div class="col-sm-9">
            <treeselect
                v-model="formItem.brands"
                :multiple="true"
                :options="brands"
                value-consists-of="LEAF_PRIORITY"
            ></treeselect>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <label>Brands Markets</label>
          </div>
          <div class="col-sm-9">
            <treeselect
                v-model="formItem.brandsMarkets"
                :multiple="true"
                :options="brandsMarkets"
                value-consists-of="LEAF_PRIORITY"
            ></treeselect>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-sm-3">
            <label>Remark</label>
          </div>
          <div class="col-sm-9">
            <b-input
                class="form-control-sm"
                v-model.trim="formItem.remark"
                maxLength="100"
            ></b-input>
          </div>
        </div>
        <b-row>
          <b-col>
            <b-alert
                variant="warning"
                :show="formItem.roles.includes('BusinessPerformanceUser')"
                class="mb-0"
            >
              <b>BusinessPerformanceUser</b>
              <p>
                This role allows user to view reports that contains data for all
                brands regardless of Brands settings
              </p>
            </b-alert>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="modal = false">Cancel</b-button>
        <b-button variant="primary" @click="AddOrEditItem"
        >{{ isEdit ? 'Edit' : 'Add' }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
        ref="reset-password-modal"
        centered
        ok-only
        hide-header
        button-size="sm"
    >
      Please copy this new password and send it to the user
      <span class="text-info">{{ resetPasswordEmail }}</span
      >.
      <div class="mt-3">
        <b-overlay
            class="d-inline-block border border-primary bg-primary rounded px-3 py-1"
            :show="copiedOverlay"
            variant="success"
            no-center
            rounded
        >
          <template #overlay>
            <span class="d-inline-block text-light copied-password"
            >Copied ...</span
            >
          </template>
          <span
              class="text-truncate new-password text-light"
              @click="copyNewPassword"
          >
            {{ newPassword }}
          </span>
        </b-overlay>
      </div>
    </b-modal>
  </div>
</template>

<script>
/*global _*/
import application from '@/mixins/application';

export default {
  name: 'users',
  mixins: [application],
  mounted() {
    var vm = this;
    vm.GetList();

    vm.axios.get('api/users/roles').then(function (resp) {
      if (resp.data) {
        vm.roles = _.map(resp.data, function (v) {
          return {id: v.name, label: v.name};
        });
      }
    });
    vm.axios.get('api/users/brands').then(function (resp) {
      if (resp.data) {
        vm.brands = _.map(resp.data, function (v) {
          return {id: v.name, label: v.name};
        });
      }
    });
    vm.axios.get('api/users/brands-markets').then(function (resp) {
      if (resp.data) {
        vm.brandsMarkets = _.map(resp.data, function (v) {
          return {id: v.name, label: v.name};
        });
      }
    });
  },
  data() {
    return {
      path: 'users',
      modal: false,
      roles: [],
      brands: [],
      brandsMarkets: [],
      formItem: {
        id: '',
        roles: [],
        brands: [],
        brandsMarkets: [],
        email: '',
        remark: '',
      },
      formItemDefault: {
        id: '',
        roles: [],
        brands: [],
        brandsMarkets: [],
        email: '',
        remark: '',
      },
      isEdit: false,
      fields: [
        {
          key: 'index',
          label: 'No.',
          sortable: false,
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true,
        },
        {
          key: 'roles',
          label: 'Roles',
          sortable: false,
        },
        {
          key: 'remark',
          label: 'Remark',
          sortable: false,
        },
        {
          key: 'action',
          label: '',
          sortable: false,
        },
      ],
      filter: null,
      filterByRole: [],
      users: [],
      perPage: 100000,
      currentPage: 1,
      isBusy: false,
      remarks: [{id: '', remark: ''}],

      newPassword: '',
      copiedOverlay: false,
      resetPasswordEmail: '',
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
    items() {
      const vm = this;
      return _.map(vm.users, function (user) {
        return _.extend(
            user,
            _.omit(_.find(vm.remarks, {userId: user.id}), 'userId')
        );
      });
    },
    filteredItems() {
      let list = this.items;
      list = _.filter(list, (item) => {
        return this.filter === null || this.filter === '' || item.email.toLowerCase().includes(this.filter.toLowerCase())
      });
      list = _.filter(list, (item) => {
        return this.filterByRole.length === 0 || _.difference(this.filterByRole, item.roles).length === 0
      })
      return list;
    }
  },
  methods: {
    GetList() {
      const vm = this;
      vm.axios.get('api/users').then(function (resp) {
        if (resp.data) {
          let users = resp.data;
          vm.axios.get('api/usermanagementremark').then(function (resp) {
            if (resp.data) {
              vm.users = users;
              vm.remarks = resp.data;
            }
          });
        }
      });
    },
    GetItem(item) {
      const vm = this;
      vm.axios.get('api/users/' + item.id).then(function (resp) {
        if (resp.data) {
          vm.formItem = resp.data;
          vm.modal = true;
        }
      });
    },
    LoadItem(item) {
      if (item) {
        this.isEdit = true;
        this.formItem = _.find(this.items, {id: item.id});
        this.modal = true;
        // this.GetItem(item);
      } else {
        this.isEdit = false;
        this.formItem = _.cloneDeep(this.formItemDefault);
        this.modal = true;
      }
    },
    AddOrEditItem() {
      const vm = this;
      const form = vm.$refs['form-user'];
      if (!form.reportValidity()) {
        return;
      }
      vm.modal = false;

      if (vm.formItem.id) {
        vm.$bvModal
            .msgBoxConfirm('Proceed to edit user?', {centered: true})
            .then(function (confirm) {
              if (confirm) {
                vm.EditItem();
              } else {
                vm.modal = true;
              }
            });
      } else {
        vm.$bvModal
            .msgBoxConfirm('Proceed to create user?', {centered: true})
            .then(function (confirm) {
              if (confirm) {
                vm.AddItem();
              } else {
                vm.modal = true;
              }
            });
      }
    },
    AddItem() {
      const vm = this;
      vm.axios
          .post('/api/users', vm.formItem)
          .then(function (resp) {
            vm.PromptSuccess('Success', 'User had been created successfully.');
            vm.resetPasswordEmail = vm.formItem.email;
            vm.newPassword = resp.data.newPassword;
            vm.$refs['reset-password-modal'].show();

            if (vm.formItem.remark) {
              vm.axios
                  .post('/api/usermanagementremark', {
                    userId: resp.data.id,
                    remark: vm.formItem.remark,
                  })
                  .then(function () {
                    vm.GetList();
                  });
            }
            vm.formItem = _.cloneDeep(vm.formItemDefault);
          })
          .catch(function () {
            vm.PromptWarning(
                'Failed',
                'Failed to create user. Please refresh page and try again.'
            );
          });
    },
    EditItem() {
      const vm = this;
      vm.axios
          .put('/api/users/' + vm.formItem.id, vm.formItem)
          .then(function () {
            vm.PromptSuccess('Success', 'User had been updated successfully.');
            // let list = _.filter(vm.users, function(a) {return a.id !== vm.formItem.id});
            // list.push(vm.formItem);
            // vm.users = list;
            vm.axios
                .post('/api/usermanagementremark', {
                  userId: vm.formItem.id,
                  remark: vm.formItem.remark,
                })
                .then(function () {
                  vm.GetList();
                });
            vm.formItem = _.cloneDeep(vm.formItemDefault);
            vm.GetList();
          })
          .catch(function () {
            vm.PromptWarning(
                'Failed',
                'Failed to update user. Please refresh page and try again.'
            );
          });
    },
    DeleteItem(item) {
      const vm = this;
      vm.$bvModal
          .msgBoxConfirm(
              'Proceed to delete user? Deleted data will be lost forever.',
              {centered: true}
          )
          .then(function (confirm) {
            if (confirm) {
              vm.axios
                  .delete('/api/users/' + item.id)
                  .then(function () {
                    vm.PromptSuccess(
                        'Success',
                        'User had been deleted successfully.'
                    );

                    vm.modal = false;
                    vm.GetList();
                  })
                  .catch(function () {
                    vm.PromptWarning(
                        'Failed',
                        'Failed to delete user. Please refresh page and try again.'
                    );
                  });
            }
          });
    },
    resetPassword(data) {
      const email = data.email;
      const h = this.$createElement;
      const messageVNode = h('div', {class: ['foobar']}, [
        h('span', [
          'Reset the password for user ',
          h('span', {class: ['text-info']}, email),
          '?',
        ]),
      ]);

      this.$bvModal
          .msgBoxConfirm(messageVNode, {centered: true, 'button-size': 'sm'})
          .then((confirm) => {
            if (confirm) {
              this.axios
                  .post('api/users/reset-password', data)
                  .then((resp) => {
                    if (resp.data) {
                      this.resetPasswordEmail = email;
                      this.newPassword = resp.data.newPassword;
                      this.$refs['reset-password-modal'].show();
                    }
                  });
            }
          });
    },
    copyNewPassword() {
      const text = `Hi,
https://sgb.bitianxia.net/Identity/Account/Login?ReturnUrl=%2FIdentity%2FAccount%2FManage%2FChangePassword
 
username: ${this.resetPasswordEmail}
password: ${this.newPassword}
Please change your password after logging in
You need to be connected to VPN to login
If you want to login without VPN in the future, please setup 2FA from the user management page after you login
https://sgb.bitianxia.net/Identity/Account/Manage/TwoFactorAuthentication
 
Main page is at https://sgb.bitianxia.net`
      navigator.clipboard.writeText(text);
      this.copiedOverlay = true;
      setTimeout(() => {
        this.copiedOverlay = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
.btn-inline-text {
  &:hover {
    cursor: pointer;
    font-weight: bold;
  }
}

.new-password {
  cursor: pointer;
}

.copied-password {
  padding: 0.2em 0 0 2em;
  font-size: 1em;
  font-weight: bold;
}

.table-pagination {
  bottom: 0;
}
</style>